import { HttpClient } from '@angular/common/http';
import { inject, Injectable, resource, ResourceRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import Stripe from 'stripe';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService {
    private readonly _http = inject(HttpClient);
    private readonly PRICE_IDS = {
        pro: 'price_pro_id', // Replace with actual Stripe price IDs
        agency: 'price_agency_id'
    };

    getCustomerSession(): ResourceRef<Stripe.CustomerSession> {
        return resource({
            loader: ({ request }) => firstValueFrom(this._http.post<Stripe.CustomerSession>('/api/payments/customer-session', request))
        });
    }

    async openBillingPortal() {
        const { url } = await firstValueFrom(this._http.post<{ url: string; }>('/api/payments/billing-portal-session', {}));

        window.open(url, '_blank');
    }

    async endTrial() {
        await firstValueFrom(this._http.post('/api/payments/subscription/end-trial', {}));
    }

    async startSubscription(plan: string) {
        /* const priceId = this.PRICE_IDS[plan];
        const response = await firstValueFrom(
          this.http.post<{ subscriptionId: string }>('/api/stripe/create-subscription', {
            priceId,
            // You'll need to get the customerId from your auth service
            customerId: 'customer_id'
          })
        );

        // Handle the subscription response
        // Typically you'd redirect to a checkout page or handle the payment flow
        return response; */
    }
}
